import { MobileYearDropdownDefinition } from '../services/layout';
import { FC, useContext, useState } from 'react';
import { useTheme } from '@material-ui/core';
import React from 'react';

import { FormControlProps } from '../utils';
import { FormContext } from '../FormContext';
import { List, makeSelectStyles, selectTheme } from './List';
import Select from 'react-select';

const YEAR_DROPDOWN_SIZE = 15; // Number of years in the past 


export interface YearDropdownProps extends FormControlProps<MobileYearDropdownDefinition> {
}


export const YearDropdown: FC<YearDropdownProps> = function(props) {
  const { definition, path } = props;
  const dataPath = definition.dataPath;
  const theme = useTheme();
  const [ selectStyles, setSelectStyles ] = useState(makeSelectStyles(theme));
  const [ year, setYear ] = useState<number>();
  const { onSetData, scope } = useContext(FormContext);

  const getYears = (): number[] => {
    const thisYear = new Date().getFullYear();
    const acc: number[] = [];
    for (let i=thisYear; i>=thisYear-YEAR_DROPDOWN_SIZE; i--) {
      acc.push(i);
    }
    return acc;
  }

  const handleChange = (yearAsString: any) => {
    const yearAsNumber = parseInt(yearAsString);
    setYear(yearAsNumber);
    onSetData(definition.name, yearAsString, scope);
  }

  return <React.Fragment>
    { dataPath && 
      <List definition={
          {
            variant: "picker",
            label: "Year",
            dataPath: dataPath,
            options: getYears(),
            wrapperStyles: {},
            type: 'List',
            multiselect: false
          }
        } path={ dataPath }>
      </List>
    }
    { !dataPath &&
      <Select
        aria-label = "Year"
        options = { getYears() }
        getOptionLabel = { ((year: any) => year.toString()) }
        getOptionValue = { ((year: any) => year.toString()) }
        isClearable
        styles = { selectStyles as any }
        onChange = { handleChange }
        value = { [year as any] }
        theme = { selectTheme(theme) as any}>
      </Select>
    }
  </React.Fragment>
}